<template>
  <div class="verify-view">
    <!-- Top bar navigation -->
    <header class="app navigation" style="flex: 0; background-color: var(--msag-color); padding: 10px; position: sticky; top:0; z-index: 10;">
      <v-container>
        <v-row justify="space-between" style="align-items: center; padding-bottom: 5px;">
          <div style="margin-right:10px;">
            <v-row justify="space-between" style="align-items: center;">
              <v-col style="flex:0;">
                <div style="background-color:white; padding: 10px; border-radius: 10px; height: 50px; width: 50px;">
                  <img src="@/assets/Maklersprechstunde-Logo.png" alt="Square Image" style="width: 30px; height: 30px;"/>
                </div>
              </v-col>
              <v-col style="flex:1; padding: 0px; margin: 0px;">
                <h1 style="color: white; text-align: left;">Portalpreise.com</h1>
              </v-col>

              <router-link to="/">
                <a class="addButton" style="margin: 5px 10px;">
                  Zur Karte
                </a>
              </router-link>
            </v-row>
          </div>
        </v-row>
      </v-container>
    </header>

    <!-- Verification result -->
    <v-container style="max-width: 720px; padding-bottom: 40px;">
      <v-card class="result-card" style="margin-top: 20px;">
        <FormSteps :current="stepperCurrent" />

        <div class="result-content">
          <div v-if="state === 'loading'">
            <v-progress-circular indeterminate color="var(--msag-color)" size="48" />
            <p style="margin-top: 20px;">Ihr Eintrag wird verifiziert...</p>
          </div>
          <div v-else-if="state === 'verified'">
            <div class="result-icon-circle icon-success">
              <svg width="44" height="44" viewBox="0 0 24 24">
                <path fill="#4caf50" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
              </svg>
            </div>
            <h2 class="title-text">Eintrag erfolgreich verifiziert!</h2>
            <p>
              Vielen Dank! Ihr Eintrag wurde bestätigt und ist damit
              <b>ab sofort veröffentlicht</b> — er fließt jetzt in die
              Portalpreise-Karte ein.
            </p>
          </div>
          <div v-else-if="state === 'already_verified'">
            <div class="result-icon-circle icon-success">
              <svg width="44" height="44" viewBox="0 0 24 24">
                <path fill="#4caf50" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
              </svg>
            </div>
            <h2 class="title-text">Bereits verifiziert</h2>
            <p>
              Dieser Eintrag wurde schon bestätigt und ist bereits veröffentlicht.
              Sie müssen nichts weiter tun.
            </p>
          </div>
          <div v-else-if="state === 'invalid'">
            <div class="result-icon-circle icon-error">
              <svg width="44" height="44" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="9" fill="none" stroke="#ff5252" stroke-width="2"/>
                <rect x="11" y="7" width="2" height="6" fill="#ff5252"/>
                <rect x="11" y="15" width="2" height="2" fill="#ff5252"/>
              </svg>
            </div>
            <h2 class="title-text">Ungültiger Link</h2>
            <p>
              Dieser Verifizierungslink ist ungültig. Bitte prüfen Sie, ob der Link
              vollständig kopiert wurde, oder erstellen Sie einen neuen Eintrag.
            </p>
          </div>
          <div v-else>
            <div class="result-icon-circle icon-error">
              <svg width="44" height="44" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="9" fill="none" stroke="#ff5252" stroke-width="2"/>
                <rect x="11" y="7" width="2" height="6" fill="#ff5252"/>
                <rect x="11" y="15" width="2" height="2" fill="#ff5252"/>
              </svg>
            </div>
            <h2 class="title-text">Etwas ist schiefgelaufen</h2>
            <p>
              Die Verifizierung konnte nicht durchgeführt werden. Bitte versuchen
              Sie es später erneut.
            </p>
          </div>

          <router-link v-if="state !== 'loading'" to="/">
            <a class="addButtonBig" style="display: inline-block; margin-top: 20px;">
              Zur Karte
            </a>
          </router-link>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { getFromServer } from "@/scripts/serverCalls";
import FormSteps from "@/components/FormSteps.vue";

export default {
  name: "VerifyView",

  components: {
    FormSteps,
  },
  data: () => ({
    state: "loading", // loading | verified | already_verified | invalid | error
  }),
  computed: {
    stepperCurrent() {
      // All steps completed on success, otherwise step 3 stays active
      if (this.state === "verified" || this.state === "already_verified") return 4;
      return 3;
    },
  },
  methods: {
    /**
     * Renders a short confetti animation in the pages colors
     */
    launchConfetti() {
      const canvas = document.createElement("canvas");
      canvas.className = "confetti-canvas";
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      document.body.appendChild(canvas);
      const ctx = canvas.getContext("2d");

      const colors = ["#237AFD", "#5C9DFF", "#A9C7F5", "#7E8A9A", "#C4CBD6", "#EAF1FB"];
      const particles = Array.from({ length: 180 }, () => ({
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.6,
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 8,
        vx: -1.5 + Math.random() * 3,
        vy: 2 + Math.random() * 3.5,
        rotation: Math.random() * Math.PI,
        rotationSpeed: -0.1 + Math.random() * 0.2,
        color: colors[Math.floor(Math.random() * colors.length)],
      }));

      const start = performance.now();
      const tick = (now) => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (const p of particles) {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += 0.04;
          p.rotation += p.rotationSpeed;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        }
        if (now - start < 6000) requestAnimationFrame(tick);
        else canvas.remove();
      };
      requestAnimationFrame(tick);
    },
  },
  async mounted() {
    const hash = this.$route.query.hash;
    if (!hash) {
      this.state = "invalid";
      return;
    }
    await getFromServer(`map/prices/verify?hash=${encodeURIComponent(hash)}`, (res) => {
      if (res?.status === 200 && res?.data?.status) this.state = res.data.status;
      else this.state = "error";
      if (this.state === "verified" || this.state === "already_verified") this.launchConfetti();
    });
  },
};
</script>
<style lang="scss">
.verify-view {
  min-height: 100vh;
  background-color: #f5f5f5;

  .result-card {
    border-radius: 16px !important;
    padding: calc(1rem + 0.5vw + 0.5vh);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08) !important;
  }

  .result-content {
    text-align: center;
    margin-top: 28px;

    p {
      margin: 12px auto 0px auto;
      max-width: 480px;
    }
  }

  .result-icon-circle {
    width: 80px;
    height: 80px;
    margin: 0 auto 16px auto;
    border-radius: 50%;
    background-color: #eaf1fb;
    display: flex;
    align-items: center;
    justify-content: center;

    &.icon-success {
      background-color: #e8f5e9;
    }
    &.icon-error {
      background-color: #fdecec;
    }
  }
}

.confetti-canvas {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 200;
}
</style>
